import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { sitePageService } from '../services/sitePageService';
import { publicPageBySlug } from '../content/publicPages';
import { PublicPageDraftContext } from '../content/sectionTone';

export function usePublicPages() {
  return useQuery({
    queryKey: ['publicPages'],
    queryFn: () => sitePageService.publicIndex(),
    staleTime: 60_000,
  });
}

export function usePublicPage(slug) {
  const draft = useContext(PublicPageDraftContext);
  const query = usePublicPages();
  const defaults = publicPageBySlug(slug)?.defaults || {};
  if (draft?.slug === slug && draft.content) {
    return { saved: draft.content, defaults, isLoading: false };
  }
  const saved = query.data?.data?.[slug] || {};
  return { saved, defaults, isLoading: query.isLoading };
}
